import ReactDOM from "react-dom/client"
import App from "./App"
import { AuthContextProvider } from "./context/AuthContext"
import { ThemeModeProvider } from "./context/ThemeContext"
import "./index.css"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <ThemeModeProvider>
    <AuthContextProvider>
      <App />
    </AuthContextProvider>
  </ThemeModeProvider>
)
